module.exports = __webpack_public_path__ + "static/bnr_wide-6d8b0c5bfab321a8a3ae19aea427d7bb.png";